import { required, SelectInput } from "react-admin";

export const projectCodeList = [
  { id: "Adhoc", name: "Adhoc" },
  { id: "DailyBus", name: "Daily Bus" },
];

const ProjectCodeInput = () => {
  return (
    <SelectInput
      source="projectCode"
      choices={projectCodeList}
      validate={required()}
    />
  );
};

export default ProjectCodeInput;
